import { OneTrustRemoteKeys } from 'types/oneTrust';

export const UnknownKeyMapping = {
  37: 'Left',
  38: 'Up',
  39: 'Right',
  40: 'Down',
  13: 'Enter',
  8: 'Back',
  27: 'Exit',

  70: 'MediaFastForward', // Mapping F Key
  79: 'MediaPlay', // Mapping O Key
  80: 'MediaPause', // Mapping P Key
  82: 'MediaRewind', // Mapping R Key
} as const;

/**
 * Back keys handed to OneTrust. A browser always sets `event.code`, which
 * OneTrust prefers over the `keyCode`, so the back key has to be given by name
 * too.
 */
export const UnknownOneTrustKeyMapping: OneTrustRemoteKeys = {
  8: 'BACK',
  Backspace: 'BACK',
};
